import { Language } from '../models/interfaces/languages/Language';

export const AVAILABLE_LANGUAGES: Array<Language> = [
  { locale: 'nl', name: 'NL' },
  { locale: 'en', name: 'EN' },
  { locale: 'ar', name: 'AR' },
];
export const DEFAULT_LANGUAGE = AVAILABLE_LANGUAGES[0];
